import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from "vue";
  import { formatPriceTrim } from "@/helpers/transformation/price";
  import AddAndUpdateAssetInGalleryModal from "@/components/ui/modals/AddAndUpdateAssetInGalleryModal.vue";
  import {
    CreateFacadeInterface,
    UpdateFacadeInterface,
  } from "@/types/FacadeInterface";
  import {
    CreateExternalColorSchemeInterface,
    CreateInternalColorSchemeInterface,
    UpdateExternalColorSchemeInterface,
    UpdateInternalColorSchemeInterface,
  } from "@/types/ColorSchemeInterface";
  import { AssetType } from "./AssetGallery.vue";
  import { AssetGalleryFormType } from "@/enums/AssetGalleryFormType";
  import {
    CreateOptionalUpgradeInterface,
    UpdateOptionalUpgradeInterface,
  } from "@/types/OptionalUpgradeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AssetItemCard',
  props: {
    builderId: {
      type: String,
      required: true,
    },
    asset: {
      type: Object as PropType<AssetType>,
      required: false,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
    },
    formType: {
      type: String as PropType<AssetGalleryFormType>,
      required: true,
    },
    uploadImage: {
      type: String,
      required: true,
    },
  },
  emits: [
    "update",
    "delete",
    "openModal",
    "createFacade",
    "updateFacade",
    "createExternalColorScheme",
    "updateExternalColorScheme",
    "createInternalColorScheme",
    "updateInternalColorScheme",
    "createOptionalUpgrade",
    "updateOptionalUpgrade",
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const assetGalleryModalOpen = ref(false);
  const reloadAssetGallery = ref(false);
  const assetToUpdate = ref<AssetType | null>(null);

  const openModal = () => {
    assetGalleryModalOpen.value = true;
    emits("openModal");
  };

  const deleteAsset = () => {
    emits("delete", props.asset);
  };

  const handleCreateFacade = (data: CreateFacadeInterface) => {
    emits("createFacade", data);
  };

  const handleUpdateFacade = (data: UpdateFacadeInterface) => {
    emits("updateFacade", data);
  };

  const handleCreateExternalColorScheme = (
    data: CreateExternalColorSchemeInterface
  ) => {
    emits("createExternalColorScheme", data);
  };

  const handleUpdateExternalColorScheme = (
    data: UpdateExternalColorSchemeInterface
  ) => {
    emits("updateExternalColorScheme", data);
  };

  const handleCreateInternalColorScheme = (
    data: CreateInternalColorSchemeInterface
  ) => {
    emits("createInternalColorScheme", data);
  };

  const handleUpdateInternalColorScheme = (
    data: UpdateInternalColorSchemeInterface
  ) => {
    emits("updateInternalColorScheme", data);
  };

  const handleCreateOptionalUpgrade = (
    data: CreateOptionalUpgradeInterface
  ) => {
    emits("createOptionalUpgrade", data);
  };

  const handleUpdateOptionalUpgrade = (
    data: UpdateOptionalUpgradeInterface
  ) => {
    emits("updateOptionalUpgrade", data);
  };

const __returned__ = { emits, props, assetGalleryModalOpen, reloadAssetGallery, assetToUpdate, openModal, deleteAsset, handleCreateFacade, handleUpdateFacade, handleCreateExternalColorScheme, handleUpdateExternalColorScheme, handleCreateInternalColorScheme, handleUpdateInternalColorScheme, handleCreateOptionalUpgrade, handleUpdateOptionalUpgrade, ref, PropType, get formatPriceTrim() { return formatPriceTrim }, AddAndUpdateAssetInGalleryModal, get CreateFacadeInterface() { return CreateFacadeInterface }, get UpdateFacadeInterface() { return UpdateFacadeInterface }, get CreateExternalColorSchemeInterface() { return CreateExternalColorSchemeInterface }, get CreateInternalColorSchemeInterface() { return CreateInternalColorSchemeInterface }, get UpdateExternalColorSchemeInterface() { return UpdateExternalColorSchemeInterface }, get UpdateInternalColorSchemeInterface() { return UpdateInternalColorSchemeInterface }, AssetType, get AssetGalleryFormType() { return AssetGalleryFormType }, get CreateOptionalUpgradeInterface() { return CreateOptionalUpgradeInterface }, get UpdateOptionalUpgradeInterface() { return UpdateOptionalUpgradeInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})